"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.page.login_page': 'Iniciar sesión',
    'app.page.registration_page': 'Registro',
};
